import { render, staticRenderFns } from "./workdetail.vue?vue&type=template&id=57687bce&scoped=true&"
import script from "./workdetail.vue?vue&type=script&lang=js&"
export * from "./workdetail.vue?vue&type=script&lang=js&"
import style0 from "./workdetail.vue?vue&type=style&index=0&id=57687bce&prod&lang=scss&"
import style1 from "./workdetail.vue?vue&type=style&index=1&id=57687bce&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57687bce",
  null
  
)

export default component.exports